import { render, staticRenderFns } from "./InspectionDetailsCard.vue?vue&type=template&id=1f5f5b44"
import script from "./InspectionDetailsCard.vue?vue&type=script&lang=js"
export * from "./InspectionDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports